import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import EncodePage from './pages/EncodePage';
import DecodePage from './pages/DecodePage';
import UrlSafePage from './pages/UrlSafePage';
import GuidePage from './pages/GuidePage';
import LanguagePage from './pages/LanguagePage';
import ImageToBase64Page from './pages/ImageToBase64Page';
import Base64ToImagePage from './pages/Base64ToImagePage';
import JsonToBase64Page from './pages/JsonToBase64Page';
import HexToBase64Page from './pages/HexToBase64Page';
import XmlToBase64Page from './pages/XmlToBase64Page';
import CsvToBase64Page from './pages/CsvToBase64Page';
import YamlToBase64Page from './pages/YamlToBase64Page';
import SvgToBase64Page from './pages/SvgToBase64Page';
import BinaryToBase64Page from './pages/BinaryToBase64Page';
import Base64SizeCalculatorPage from './pages/Base64SizeCalculatorPage';
import Base64ValidatorPage from './pages/Base64ValidatorPage';
import Base64MimeEncodePage from './pages/Base64MimeEncodePage';
import Base64VsHexVsBase32Page from './pages/articles/Base64VsHexVsBase32Page';
import IsBase64EncryptionPage from './pages/articles/IsBase64EncryptionPage';
import JwtBase64UrlPage from './pages/articles/JwtBase64UrlPage';
import Base64DataUriGuidePage from './pages/articles/Base64DataUriGuidePage';
import Base64FileSizeOverheadPage from './pages/articles/Base64FileSizeOverheadPage';
import Base64EncodingErrorsPage from './pages/articles/Base64EncodingErrorsPage';
import Base64ForEmailAttachmentsPage from './pages/articles/Base64ForEmailAttachmentsPage';
import Base64DatabaseStoragePage from './pages/articles/Base64DatabaseStoragePage';
import { LANGUAGE_GUIDES } from './lib/snippets';

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/base64-encode" element={<EncodePage />} />
          <Route path="/base64-decode" element={<DecodePage />} />
          <Route path="/url-safe-base64" element={<UrlSafePage />} />
          <Route path="/what-is-base64" element={<GuidePage />} />

          {/* Language how-to pages, one shared component per language */}
          {LANGUAGE_GUIDES.map((g) => (
            <Route
              key={g.slug}
              path={`/base64-encode-${g.slug}`}
              element={<LanguagePage slug={g.slug} />}
            />
          ))}

          {/* Additional converter tools */}
          <Route path="/image-to-base64" element={<ImageToBase64Page />} />
          <Route path="/base64-to-image" element={<Base64ToImagePage />} />
          <Route path="/json-to-base64" element={<JsonToBase64Page />} />
          <Route path="/hex-to-base64" element={<HexToBase64Page />} />
          <Route path="/xml-to-base64" element={<XmlToBase64Page />} />
          <Route path="/csv-to-base64" element={<CsvToBase64Page />} />
          <Route path="/yaml-to-base64" element={<YamlToBase64Page />} />
          <Route path="/svg-to-base64" element={<SvgToBase64Page />} />
          <Route path="/binary-to-base64" element={<BinaryToBase64Page />} />
          <Route path="/base64-size-calculator" element={<Base64SizeCalculatorPage />} />
          <Route path="/base64-validator" element={<Base64ValidatorPage />} />
          <Route path="/base64-mime-encode" element={<Base64MimeEncodePage />} />

          {/* Educational articles */}
          <Route path="/base64-vs-hex-vs-base32" element={<Base64VsHexVsBase32Page />} />
          <Route path="/is-base64-encryption" element={<IsBase64EncryptionPage />} />
          <Route path="/jwt-base64url-encoding" element={<JwtBase64UrlPage />} />
          <Route path="/base64-data-uri-guide" element={<Base64DataUriGuidePage />} />
          <Route path="/base64-file-size-overhead" element={<Base64FileSizeOverheadPage />} />
          <Route path="/base64-encoding-errors" element={<Base64EncodingErrorsPage />} />
          <Route path="/base64-for-email-attachments" element={<Base64ForEmailAttachmentsPage />} />
          <Route path="/base64-database-storage" element={<Base64DatabaseStoragePage />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;
